$('.modal[data-open=onload]').each(function () {
    let bsModal = new bootstrap.Modal(this, {});
    bsModal.show()
})

$('#faq_form_modal').on('shown.bs.modal', function () {
    $('#faq_form_wrap select').select2({
        dropdownParent: $('#faq_form_wrap'),
        minimumResultsForSearch: -1
    });
});